export default class Backoff {
	#reject = () => {};
	#attempts = 0;
	#timer = /** @type {ReturnType<typeof setTimeout> | undefined} */ (undefined);

	increment() {
		/** @type {PromiseWithResolvers<void>} */
		const { promise, resolve, reject } = Promise.withResolvers();
		this.#reject = reject;

		// calculate the max timeout
		const max = 1000 * (1 << this.#attempts);

		// calculate the actual sleep time (a random number between max/2 and max)
		const sleep = max / 2 + Math.floor(Math.random() * (max / 2));
		if (this.#attempts < 10) this.#attempts += 1;

		this.#timer = setTimeout(resolve, sleep);

		return promise;
	}

	stop() {
		this.#reject();
		this.#reject = () => {};
		this.#attempts = 0;

		if (this.#timer !== undefined) {
			clearTimeout(this.#timer);
			this.#timer = undefined;
		}
	}
}
